module.exports = __webpack_public_path__ + "static/media/Bentham-Regular.c9344e00.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Bentham-Regular.ttf
// module id = 2899
// module chunks = 51